import React, { useState } from 'react';
import TextareaAutosize from 'react-textarea-autosize';

import SendIcon from '@common/assets/icons/send.svg?react';
import { IconButton } from '@common/ui/buttons/IconButton';

import styles from './ChatMessageInput.module.scss';

export type ChatMessageInputProps = {
  onSend: (text: string) => void;
  style?: React.CSSProperties;
  placeholder?: string;
  onFocus?: React.FocusEventHandler<HTMLTextAreaElement>;
};

export const ChatMessageInput: React.FC<ChatMessageInputProps> = ({
  onSend,
  style,
  placeholder,
  onFocus,
}) => {
  const [inputValue, setInputValue] = useState('');

  const canSendMessage = inputValue.trim().length > 0;

  const onSendHandler = () => {
    if (canSendMessage) {
      onSend(inputValue);
      setInputValue('');
    }
  };

  return (
    <div className={styles.chatMessageInput} style={style}>
      <div className={styles.inputContainer}>
        <TextareaAutosize
          data-test-id="chat-message-input-textarea"
          className={styles.input}
          placeholder={placeholder}
          value={inputValue}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
            setInputValue(e.currentTarget.value)
          }
          minRows={1}
          maxRows={4}
          onFocus={onFocus}
        />
      </div>

      <IconButton
        testId="chat-message-input-send-button"
        className={styles.icon}
        disabled={!canSendMessage}
        onClick={onSendHandler}
      >
        <SendIcon />
      </IconButton>
    </div>
  );
};

ChatMessageInput.displayName = 'ChatMessageInput';
